import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../api/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const deactivateUser = async (userId) => {
  const { data } = await authApiClient.delete(`/users/${userId}`);
  return data;
};

export const useDeactivateUserHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deactivateUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: data?.message || 'User deactivated successfully',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : 'Failed to deactivate user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
